"use strict";

var paymentWidget = function () {
  var paymentWidgetParams = {
    model: {},
    url: {},
    template: {}
  };
  var $paymentClarifyContent = null;

  function hidePaymentClarify(e) {
    var $paymentClarify = $('.payment-clarify');

    if (!$paymentClarifyContent.is(e.target) && $paymentClarifyContent.has(e.target).length === 0 && !$paymentClarify.is(e.target) && $paymentClarify.has(e.target).length === 0) {
      $paymentClarifyContent.hide();
    }
  }

  function cacheNodes() {
    $paymentClarifyContent = $('.payment-clarify-content');
  }

  function unbindHandlers() {
    $(document).off('click', '#printPaymentTbl');
    $(document).off('click', '.payment-clarify');
    $(document).off('mouseup', hidePaymentClarify);
    $(document).off('click', '#howToPay');
  }

  function setParams(paymentParams) {
    paymentWidgetParams = $.extend(true, paymentWidgetParams, paymentParams);
  }

  function bindHandlers() {
    $(document).on('mouseup', hidePaymentClarify);
    $(document).on('click', '#printPaymentTbl', function () {
      /* const $paymentTbl = $('.payment-detalization');
      const printWindow = window.open('');
        printWindow.document.write($paymentTbl[0].outerHTML);
      printWindow.print();
      printWindow.close(); */
    });
    $(document).on('click', '.payment-clarify', function () {
      if ($paymentClarifyContent.is(':visible')) {
        $paymentClarifyContent.hide();
      } else {
        $paymentClarifyContent.show();
      }
    });
    $(document).on('click', '#howToPay', function () {
      var printWindow = window.open();
      var paymentDetails = "<!DOCTYPE html>\n                <html lang=\"ru\">\n                <head>\n                    <meta charset=\"UTF-8\">\n                    <meta name=\"viewport\" content=\"width=device-width, initial-scale=1.0\">\n                    <meta http-equiv=\"X-UA-Compatible\" content=\"ie=edge\">\n                    <title>\u041F\u0440\u0435\u0434\u043F\u0440\u043E\u0441\u043C\u043E\u0442\u0440</title>\n                    <link href=\"/Content/custom/css/printForm.css\" rel=\"stylesheet\">\n                </head>\n                <body class=\"-light\">\n                    <main class=\"print-content\">\n                        ".concat(paymentWidgetParams.model.howToPay, "\n                        <button onClick=\"window.print();\" class =\"btn -small -secondary -padded-top -fixed-185\">\u0420\u0430\u0441\u043F\u0435\u0447\u0430\u0442\u0430\u0442\u044C \u043F\u0430\u043C\u044F\u0442\u043A\u0443</button>\n                    </main>\n                </body>\n                </html>");
      printWindow.document.write(paymentDetails);
      printWindow.document.close();
    });
  }

  function init(paymentParams) {
    unbindHandlers();
    cacheNodes();
    setParams(paymentParams);
    bindHandlers();
  }

  return {
    init: init
  };
}();